import questionEvents from './views/question.events'
import SearchResultPerson from './views/SearchResultPerson.events'
import SMAskEvents from './ui/SMAsk.events'
import termsEvents from './views/terms.events'
import userInfo from './views/userInfo.events'
import userSkills from './views/userSkills.events'

export default {
  ...questionEvents,
  ...SearchResultPerson,
  ...SMAskEvents,
  ...termsEvents,
  ...userInfo,
  ...userSkills
}
